export default __webpack_public_path__ + "static/media/poster-s.91601cec.webp";